import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import AuthCornerImage from 'assets/img/illustrations/authentication-corner.png';
import { breakpoints, capitalize } from 'helpers/utils';
import { topNavbarBreakpoint } from 'config';
import '../navbar-tw.scss';

/**
 * Top-nav hover dropdown. Local popover: hover opens on desktop
 * (>= topNavbarBreakpoint), click toggles on mobile, outside-click/Escape
 * closes. Panel styled with tailwind (was falcon dropdown-menu-card).
 */
const NavbarDropdown = ({ title, children }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!dropdownOpen) return undefined;
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    const onKey = (e) => { if (e.key === 'Escape') setDropdownOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [dropdownOpen]);

  return (
    <div
      className="tw-relative"
      ref={rootRef}
      onMouseOver={() => {
        let windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(true);
        }
      }}
      onMouseLeave={() => {
        let windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(false);
        }
      }}
    >
      <Link
        to="#!"
        className="ptl-dropdown-toggle tw-block tw-px-2 tw-py-2 tw-font-semibold tw-text-[rgba(0,0,0,0.55)] hover:tw-text-[rgba(0,0,0,0.9)] tw-no-underline tw-transition-colors"
        aria-expanded={dropdownOpen}
        onClick={(e) => {
          e.preventDefault();
          setDropdownOpen(!dropdownOpen);
        }}
      >
        {capitalize(title)}
      </Link>
      {dropdownOpen && (
        <div
          className="tw-absolute tw-left-0 tw-top-full tw-bg-white tw-rounded tw-shadow-xl tw-border tw-border-solid tw-border-slate-200 tw-z-[1050]"
          onClick={() => setDropdownOpen(false)}
        >
          <div
            className={classNames('tw-relative tw-bg-white tw-rounded tw-overflow-hidden', {
              'md:tw-min-w-[32rem]': title === 'app',
              'md:tw-min-w-[28rem] 2xl:tw-min-w-[45rem]': title === 'pages',
              'md:tw-min-w-[28.8125rem] 2xl:tw-min-w-[53.125rem]':
                title === 'modules'
            })}
          >
            <div
              className={classNames('tw-overflow-auto tw-max-h-[75vh]', {
                'tw-p-0 tw-py-2':
                  title === 'dashboard' || title === 'documentation',
                'tw-p-4': title !== 'dashboard' && title !== 'documentation'
              })}
            >
              {title !== 'dashboard' && title !== 'documentation' && (
                <img
                  src={AuthCornerImage}
                  alt=""
                  className="tw-absolute tw-bottom-0 tw-right-0"
                  width={130}
                />
              )}
              {children}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

NavbarDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default NavbarDropdown;
